import React, { useEffect, useState } from 'react';

import './pre-approved-home.scss';

import IconCheck from 'assets/svg/icon-check';
import { Button, Input } from 'components/commons';
import { Form, Field } from 'components/form-validation';
import { preApprovedHomeSchema } from 'validation-schemas/direto';
import {
    useCreateLoanApplicationFromPreQualifiedLoanMutation,
    PreQualifiedLoanStatus,
    LoanApplicationStatus,
    PreQualifiedLoanOwner,
    useLatestPreQualifiedLoanLazyQuery,
    useLoanApplicationByPreQualifiedLeadIdLazyQuery
} from 'generated/graphql';
import useRouter from 'use-react-router';
import { setStep, Step } from 'actions/step.action';
import TrustpilotWidget from 'components/commons/trustpilot-widget/trustpilot-widget';
import useNavigation from 'hooks/navigation';
import { useProduct } from 'providers/product.provider';

const PreApprovedHome: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const [id, setId] = useState<string>();
    const { buildUrl } = useNavigation();
    const { history } = useRouter();
    const { setCurrentScreen } = useProduct();
    const [createLoanApplicationFromPreQualifiedLoan] = useCreateLoanApplicationFromPreQualifiedLoanMutation();
    const [latestPreQualifiedLoanQuery] = useLatestPreQualifiedLoanLazyQuery();
    const [loanApplicationByPreQualifiedLeadIdQuery] = useLoanApplicationByPreQualifiedLeadIdLazyQuery();

    setStep(Step.PRODUCT_HOME);

    useEffect(() => {
        setId(new URLSearchParams(location.search).get("id"));
    }, [location])

    const onSubmit = async value => {
        setCurrentScreen(null);
        setLoading(true);
        try {
            const response = await latestPreQualifiedLoanQuery({
                variables: {
                    preQualifiedLoanId: value.companyDocument, owner: PreQualifiedLoanOwner.Ambev
                }
            })

            if (!response.data.latestPreQualifiedLoan) {
                goToPreQualifiedNotFound();
            } else if (
                response.data.latestPreQualifiedLoan.status ===
                PreQualifiedLoanStatus.Awaiting
            ) {
                const {
                    data: {
                        createLoanApplicationFromPreQualifiedLoan: loanApplication,
                    },
                } = await createLoanApplicationFromPreQualifiedLoan({
                    variables: {
                        loanApplicationFromPreQualifiedInput:
                        {
                            preQualifiedLoanId: id,
                            owner: PreQualifiedLoanOwner.Ambev
                        },
                    }
                });

                history.push(
                    `/${loanApplication.id}/${window.location.search}`
                );
            } else {
                handlerPreQualifiedAccepted(response.data.latestPreQualifiedLoan);
            }
        } catch {
            goToPreQualifiedNotFound();
        }
    };

    const handlerPreQualifiedAccepted = async latestPreQualifiedLoan => {
        const response = await loanApplicationByPreQualifiedLeadIdQuery({
            variables: {
                id: latestPreQualifiedLoan.id
            }
        })

        if (!response.data.loanApplicationByPreQualifiedLeadId) {
            goToPreQualifiedNotFound();
        } else {
            if (
                response.data.loanApplicationByPreQualifiedLeadId.status ===
                LoanApplicationStatus.Denied
            ) {
                history.push(
                    buildUrl(
                        '/:loanApplicationId/negado',
                        response.data.loanApplicationByPreQualifiedLeadId.id
                    )
                );
            } else if (
                latestPreQualifiedLoan.status ===
                PreQualifiedLoanStatus.Accepted
            ) {
                history.push(
                    buildUrl(
                        '/:loanApplicationId/resumo',
                        response.data.loanApplicationByPreQualifiedLeadId.id
                    )
                );
            }
        }
    };
    const goToPreQualifiedNotFound = () => {
        history.push(`/nao-encontrado/${window.location.search}`);
    };
    return (
        <Form
            schema={preApprovedHomeSchema}
            initialValues={{}}
            onSubmit={onSubmit}
            render={() => (
                <div className="message-box-container pre-approved-home-box-container">
                    <div className="inner">
                        <div className="screen">
                            <div className="home">
                                <div className="content">
                                    <h1 className="text-primary">
                                        empréstimo para empresas
                                    </h1>
                                    <div className="body-1">
                                        <p className="">
                                            A Biz tem um jeito único de oferecer{' '}
                                            <br /> crédito rápido, seguro e
                                            online.
                                        </p>
                                    </div>
                                    <p className="subtitle">
                                        saiba agora se sua empresa já tem um
                                        crédito pré-aprovado na biz
                                    </p>
                                    <div className="company-document">
                                        <Field
                                            component={Input}
                                            placeholder="CNPJ"
                                            name="companyDocument"
                                            mask="cnpj"
                                        />
                                    </div>
                                </div>
                                <div>
                                    <div className="bizcap">
                                        <div className="box">
                                            <div className="box-content">
                                                <div className="">
                                                    <div className="flex flex-row">
                                                        <div className="mt-3">
                                                            <IconCheck />
                                                        </div>
                                                        <div className="text body-2">
                                                            Empréstimo sem
                                                            garantias reais. Até
                                                            R$200 mil, em 24x e
                                                            juros a partir de
                                                            1,99% ao mês
                                                        </div>
                                                    </div>
                                                    <div className="flex flex-row mt-5">
                                                        <div className="mt-3">
                                                            <IconCheck />
                                                        </div>
                                                        <div className="text body-2">
                                                            Com a Biz, o
                                                            dinheiro pode cair
                                                            na conta da sua
                                                            empresa no mesmo
                                                            dia.{' '}
                                                        </div>
                                                    </div>
                                                    <div className="flex flex-row mt-5">
                                                        <div className="mt-3">
                                                            <IconCheck />
                                                        </div>
                                                        <div className="text body-2">
                                                            Financie o seu
                                                            capital de giro,
                                                            estoque, expansão ou
                                                            reforma e mais
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex-1 mt-3 sm-show">
                                        <TrustpilotWidget width="100%" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer">
                        <div className="screen">
                            <div className="footer-content">
                                <div className="button">
                                    <Button
                                        type="submit"
                                        variant="primary"
                                        label="começar"
                                        className="btn"
                                        loading={loading}
                                    />
                                </div>
                                <div className="flex-1 mt-3 md-show trustpilot">
                                    <TrustpilotWidget
                                        width="100%"
                                        height="20px"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        />
    );
};

export default PreApprovedHome;
